// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const SESSION_TIMEOUT = 25 * 60 * 1000; // 25 minutes

// function SessionChecker() {
//   const navigate = useNavigate();
//   const timeoutRef = useRef(null);

//   useEffect(() => {
//     const checkSession = () => {
//       const loginTime = localStorage.getItem("loginTime");

//       if (!loginTime) {
//         return;
//       }

//       const currentTime = Date.now();

//       const diff = currentTime - Number(loginTime);

//       // console.log("Session time:", Math.floor(diff / 1000), "seconds");

//       if (diff >= SESSION_TIMEOUT) {
//         localStorage.clear();

//         sessionStorage.clear();

//         window.alert("Session expired. Please login again.");

//         navigate("/", {
//           replace: true,
//         });
//       }
//     };

//     checkSession();

//     const interval = setInterval(
//       checkSession,
//       10000, // check every 10 seconds
//     );

//     return () => {
//       clearInterval(interval);
//     };
//   }, [navigate]);

//   return null;
// }

// export default SessionChecker;


import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const IDLE_TIMEOUT = 25 * 60 * 1000; // 25 minutes

function SessionChecker() {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  useEffect(() => {
    const logoutUser = () => {
      localStorage.clear();
      sessionStorage.clear();

      alert("Session expired due to inactivity. Please login again.");

      navigate("/", { replace: true });
    };

    const resetTimer = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(logoutUser, IDLE_TIMEOUT);
    };

    // User activity events
    const events = [
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
      "touchstart",
    ];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // Start timer on component load
    resetTimer();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [navigate]);

  return null;
}

export default SessionChecker;